import React from 'react'
import chroma from "chroma-js"

const NetworkView = ({networkOutput, network, dataset}) => {
  const colorScale = chroma.scale(["black", "red"])

  // calculate locations of nodes
  const nodes = []

  // vertical spacing between nodes
  const vSpace = 100

  // viewport width
  const vbWidth = 1200

  // left margin
  const lMargin = 200

  // right margin
  const rMargin = 200

  // viewport height
  const largestLayer = networkOutput.outputMap.reduce((max, curLayer) => {
    return curLayer.length > max ? curLayer.length : max
  }, 0)

  const vbHeight = largestLayer * vSpace

  // layer spacing
  const lSpacing = (vbWidth - lMargin - rMargin) / (networkOutput.outputMap.length - 1)


  if(networkOutput) {
    // get vertical center of graph
    const maxLayer = Math.max(
      ...networkOutput.outputMap.map((l) => 
        l.length
      )
    )
    const vCenter = (vSpace * maxLayer) / 2

    // calculate locations of nodes
    networkOutput.outputMap.forEach((o, i) => {
      const layerNodes = []
      let vStart = vCenter - (((o.length - 1) / 2) * vSpace)
      o.forEach((l, j) => {
        let node = {}
        node.x = lMargin + i * lSpacing
        node.y = vStart + j * vSpace
        node.color = colorScale(l)
        layerNodes.push(node)
      })
      nodes.push(layerNodes)
    })
  }

  // calculate locations of lines
  const lines = []
  for(let i = 0; i < nodes.length - 1; i ++) {
    for(let j = 0; j < nodes[i].length; j++) {
      for(let k = 0; k < nodes[i + 1].length; k++) {
        let line = {}

        // starting node
        line.x1 = nodes[i][j].x
        line.y1 = nodes[i][j].y

        // node in next layer
        line.x2 = nodes[i + 1][k].x
        line.y2 = nodes[i + 1][k].y

        // get stroke from starting node
        line.stroke = nodes[i][j].color
      
        lines.push(line)
      }
    }
  }

  return (
    <div>
      <svg viewBox={`0 0 ${vbWidth} ${vbHeight}`}>
        {
          lines.map((l, i) => 
            <line
              key={i}
              x1={l.x1}
              y1={l.y1}
              x2={l.x2}
              y2={l.y2}
              stroke={l.stroke}
            />
          )
        }
        {
          nodes.flat().map((n, i) => 
            <circle
              key={i}
              cx={n.x}
              cy={n.y}
              r="20"
              style={{
                fill: n.color
              }}
            />
          )
        }
        {
          nodes[0].map((n, i) => 
            <text
              x={n.x - 30}
              y={n.y + 5}
              textAnchor='end'
            >{dataset.feature_names[i]}</text>
          )
        }
        {
          nodes[nodes.length - 1].map((n, i) => 
            <text
              x={n.x + 30}
              y={n.y + 5}
            >{dataset.class_names[i]}</text>
          )
        }
      </svg>
    </div>
  )
}

export {
  NetworkView
}